module.exports = __webpack_public_path__ + "static/media/shirt2.75bd0137.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Product/shirt2.png
// module id = 259
// module chunks = 0